import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSortColumns = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 7,
	viewBox: "0 0 21 7",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#4A5666",
		children: [/* @__PURE__ */ _jsx("path", {
			strokeLinecap: "square",
			strokeWidth: 1.5,
			d: "M7.071 3.607h10"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#4A5666",
			strokeWidth: 2,
			d: "m18.642 3.607-3 1.5v-3zM2.571 3.607l3-1.5v3z"
		})]
	})
});
export default SvgSortColumns;
